import { render, staticRenderFns } from "./HomeworkTimeCard.vue?vue&type=template&id=36e380ac&scoped=true"
import script from "./HomeworkTimeCard.vue?vue&type=script&lang=js"
export * from "./HomeworkTimeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeworkTimeCard.vue?vue&type=style&index=0&id=36e380ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e380ac",
  null
  
)

export default component.exports